import userServices from '../services/userServices';

export const fetchPwnDataRequest = () => ({ type: 'FETCH_PWN_DATA_REQUEST' });
export const fetchPwnDataSuccess = (profiles) => ({ type: 'FETCH_PWN_DATA_SUCCESS', profiles });
export const fetchPwnDataError = (message, form) => ({ type: 'FETCH_PWN_DATA_ERROR', message, form });
export const UPDATE_TRACKER_INSTALLATION_TYPE = 'UPDATE_TRACKER_INSTALLATION_TYPE';

export const updateTrackerInstallationType = (value) => ({
    type: UPDATE_TRACKER_INSTALLATION_TYPE,
    payload: value
});

export const fetchPwnData = () => (dispatch) =>
    new Promise((resolve, reject) => {
        dispatch(fetchPwnDataRequest());

        userServices.fetchPwnTracker().then(
            (response) => {
                const res = response.data;
                dispatch(fetchPwnDataSuccess(res));
                resolve(res);
            },
            (error) => {
                const { message, form = {} } = error.data;
                dispatch(fetchPwnDataError(message, form));
                return reject({ message, form });
            }
        );
    });
